import { FormItem } from '@/providers'

export const OnboardingFirstNameStep = () => (
  <FormItem name="patient_first_name" label="Vorname" componentProps={{ inputType: 'name' }} />
)
